import * as React from "react";
import * as ReactDOM from "react-dom";
import { TabControlTemplate } from "./";

interface IProperties
{
    /**
     * Das Template des Tabs. Hiermit kann das Design des Tabs verändert werden.
     */
    template?: TabControlTemplate,

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Der Index des Tabs.
     */
    index?: number,

    /**
     * Icon (Wenn angegeben wird nur das Icon angezeigt und nicht der Text).
     */
    icon?: string,

    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Gibt an, ob dieses Tab selektiert ist.
     */
    isSelected?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Tab geklickt wird.
     */
    onClick?: (index: number) => void
}

export class Tab extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        isSelected: false
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(this.props.index);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { template, style, icon, text, isSelected } = this.props;
        const classNames: string[] = [];

        switch (template)
        {
            case TabControlTemplate.style2:
                {
                    classNames.push("tabcontrol_tab_style2");

                    if (isSelected)
                        classNames.push("tabcontrol_tab_style2--selected");
                }
                break;
            default:
                {
                    classNames.push("tabcontrol_tab");

                    if (isSelected)
                        classNames.push("tabcontrol_tab--selected");
                }
                break;
        }

        return (
            <div
                style={style}
                className={classNames.join(" ")}
                onClick={this.onClick}>
                {icon && <i className={`mdi mdi-${icon}`}></i>}
                {text && <span>{text}</span>}
            </div>
        );
    }
}